import {
    endOfMonth,
    endOfWeek,
    startOfWeek,
    startOfMonth,
    endOfYear,
    startOfYear,
    subWeeks,
    subDays,
  } from "date-fns";
  import { SummaryRanges } from "../sharedTypes/wallet-types";

  export const MDY_DATE_FORMAT_THREE = "yyyy-MM-dd";
  
  export function getSummaryRangeDates(range: SummaryRanges) {
    let endDate = new Date();
    let startDate = new Date();
  
    if (range === "TODAY") {
      endDate = new Date();
      startDate = endDate;
    }
  
    if (range === "THIS_WEEK") {
      endDate = endOfWeek(new Date());
      startDate = startOfWeek(endDate);
    }
  
    if (range === "THIS_MONTH") {
      endDate = endOfMonth(new Date());
      startDate = startOfMonth(endDate);
    }
  
    if (range === "THIS_YEAR") {
      endDate = endOfYear(new Date());
      startDate = startOfYear(endDate);
    }
  
    if (range === "LAST_WEEK") {
      endDate = endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });
      startDate = startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 });
    }
  
    if (range === "LAST_7_DAYS") {
      endDate = new Date();
      startDate = subDays(new Date(), 7);
    }
  
    return { startDate, endDate };
  }
